import { ReactNode } from "react";
import "./title.sass";

type Props = {
  children: ReactNode;
};

const Title = ({ children }: Props) => {
  return <div className="title">{children}</div>;
};

export default Title;
